import { Grid } from '@mui/material';
import { useReducer, useState } from 'react';
import { Item } from '../../utils/sharedTypes';
import UsersFilterBar from './UsersFilterBar';
import UsersOptionsBar from './UsersOptionsBar';
import UsersTable from './UsersTable';
import { UserFilter } from './userTypes';

const initialFilters: UserFilter = {
  company: null,
  name: '',
  email: '',
  role: undefined,
};

const Users = () => {
  const [filters, setFilters] = useReducer(
    (curVals: UserFilter, newVals: any) => ({
      ...curVals,
      ...newVals,
    }),
    initialFilters
  );
  const [selectedUsers, setSelectedUsers] = useState<Item[]>([]);
  const [editModalOpenFlag, setEditModalOpenFlag] = useState<boolean>(false);
  return (
    <>
      <Grid container spacing={1} alignItems='center'>
        <Grid item>
          <UsersFilterBar
            filters={filters}
            setFilters={setFilters}
            initialFilters={initialFilters}
          />
        </Grid>
        <Grid item>
          <UsersOptionsBar
            editModalOpenFlag={editModalOpenFlag}
            setEditModalOpenFlag={setEditModalOpenFlag}
            selectedUsers={selectedUsers}
            setSelectedUsers={setSelectedUsers}
          />
        </Grid>
      </Grid>
      <UsersTable
        setEditModalOpenFlag={setEditModalOpenFlag}
        setSelectedUsers={setSelectedUsers}
        filters={filters}
      />
    </>
  );
};

export default Users;
